import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { Order } from '@/types/order';
import Table from '@/components/molecules/section/Table';
import Container from '@/components/molecules/section/Container';

const View: React.FC<{ order: Order }> = ({ order }) => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'productId', headerName: t('order.buyer_payment_breakdown.item_id') },
    { field: 'price', headerName: t('order.buyer_payment_breakdown.price') },
    { field: 'authenticationFee', headerName: t('order.buyer_payment_breakdown.authentication_fee') },
    { field: 'shippingFee', headerName: t('order.buyer_payment_breakdown.shipping_fee') },
    { field: 'dutyFee', headerName: t('order.buyer_payment_breakdown.duty_fee') },
    { field: 'buyerServiceFee', headerName: t('order.buyer_payment_breakdown.buyer_service_fees') },
    {
      field: 'discount',
      headerName: t('order.buyer_payment_breakdown.discount'),
      description: t('order.buyer_payment_breakdown.discount_description'),
    },
  ];

  const rows =
    order.products !== undefined
      ? order.products.map((product, index) => ({
          ...product,
          id: index,
        }))
      : [];

  return (
    <Container
      title={t('order.buyer_payment_breakdown.title')}
      actions={[]}
      testId="buyer_payment_breakdown"
    >
      <Table
        rows={rows}
        columns={columns}
        loading={false}
        table={{
          kind: 'Table',
        }}
      />
    </Container>
  );
};

export default View;
